// Rummy Samrat maroon + gold theme for react-select dropdowns.
// Usage: <Select {...themedSelectProps} options={...} />

const MAROON_DARK = "#2a0507";
const MAROON = "#5a0b10";
const GOLD_LIGHT = "#fff1a8";
const GOLD = "#e8b923";
const GOLD_DARK = "#9c6a12";

export const themedSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: 50,
    paddingLeft: 6,
    backgroundColor: state.isFocused ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0.35)",
    borderColor: state.isFocused ? GOLD : "rgba(232, 185, 35, 0.55)",
    boxShadow: state.isFocused
      ? "0 0 0 0.2rem rgba(232, 185, 35, 0.25), 0 0 12px rgba(232, 185, 35, 0.3)"
      : "none",
    cursor: "pointer",
    "&:hover": { borderColor: GOLD },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 8px" }),
  singleValue: (base) => ({ ...base, color: GOLD_LIGHT, fontWeight: 500 }),
  input: (base) => ({ ...base, color: GOLD_LIGHT }),
  placeholder: (base) => ({
    ...base,
    color: "rgba(255, 241, 168, 0.5)",
    fontSize: 14,
    fontWeight: 500,
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: "rgba(232, 185, 35, 0.4)",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: GOLD,
    padding: "0 10px",
    "&:hover": { color: GOLD_LIGHT },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: GOLD,
    padding: "0 6px",
    "&:hover": { color: GOLD_LIGHT },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({
    ...base,
    marginTop: 6,
    overflow: "hidden",
    borderRadius: 12,
    background: `linear-gradient(180deg, ${MAROON} 0%, ${MAROON_DARK} 100%)`,
    border: `1px solid ${GOLD_DARK}`,
    boxShadow: "0 10px 24px rgba(0, 0, 0, 0.6), 0 0 12px rgba(232, 185, 35, 0.2)",
  }),
  menuList: (base) => ({ ...base, padding: 4 }),
  option: (base, state) => ({
    ...base,
    borderRadius: 8,
    fontSize: 14,
    fontWeight: state.isSelected ? 700 : 500,
    cursor: "pointer",
    color: state.isSelected ? MAROON_DARK : GOLD_LIGHT,
    background: state.isSelected
      ? `linear-gradient(160deg, ${GOLD_LIGHT} 0%, ${GOLD} 45%, ${GOLD_DARK} 100%)`
      : state.isFocused
        ? "rgba(232, 185, 35, 0.15)"
        : "transparent",
    "&:active": { backgroundColor: "rgba(232, 185, 35, 0.3)" },
  }),
  noOptionsMessage: (base) => ({ ...base, color: "rgba(255, 241, 168, 0.6)" }),
  loadingMessage: (base) => ({ ...base, color: "rgba(255, 241, 168, 0.6)" }),
};

// Portal the menu to <body> so containers with overflow:hidden (e.g. the
// list-page search bar) don't clip it.
export const themedSelectProps = {
  styles: themedSelectStyles,
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "absolute",
};
